module.exports = __webpack_public_path__ + "img/aeroland-clinic-hero-image.cd52c93d.png";